import type { Testimonial } from "@/components/feature/LeistungsseiteTemplate";

/**
 * Echte Kundenstimmen aus den Leistungs- und Für-wen-Seiten.
 * Keine erfundenen Zitate — nur bereits vorhandene, freigegebene Stimmen.
 */
export const allTestimonials: Testimonial[] = [
  {
    quote:
      "Alles aus einer Hand geplant und installiert — wir mussten uns um nichts kümmern.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Endlich ein Ansprechpartner, der von der Beratung bis zur fertigen Anlage alles aus einer Hand macht.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Mit dem Speicher nutzen wir endlich unseren eigenen Strom auch abends — genau wie versprochen.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Wallbox angefragt, beraten, installiert und angemeldet — alles über einen Ansprechpartner. So muss das sein.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Die Wärmepumpe läuft jetzt mit unserem eigenen Solarstrom — sauber eingebunden und gesteuert.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Endlich ein durchdachtes System statt zehn verschiedener Apps — und alles vom selben Ansprechpartner installiert.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Beim letzten Stromausfall lief unser Haus einfach weiter — genau dafür haben wir es gemacht.",
    name: "Familie",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Die PV-Anlage auf unserer Halle senkt unsere Stromkosten deutlich — sauber geplant und installiert.",
    name: "Betrieb",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Unser Scheunendach erzeugt jetzt den Strom, den der Hof tagsüber braucht — eine runde Sache.",
    name: "Landwirt",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Mieterstromkonzept sauber umgesetzt — unsere Mieter profitieren und das Gebäude ist zukunftssicher.",
    name: "Eigentümer",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Schnell, gründlich und verständlich erklärt — wir wissen jetzt, dass alles sicher ist.",
    name: "Kunde",
    location: "Emmerich am Rhein und Umgebung",
  },
  {
    quote:
      "Erst die Anlage installiert, dann intelligent gesteuert — wir sehen genau, was unser System leistet.",
    name: "Kunde",
    location: "Emmerich am Rhein und Umgebung",
  },
];
